import {Outlet} from "react-router-dom"
import { MainAdminSidebar,MainAdminTop } from "../components";

const LayoutMainAdmin = () =>{

    return(
        <div className="bg-backGray flex">
            <div><MainAdminSidebar/></div>
            <div className="w-full px-[20px] pt-[51px]">
                <div><MainAdminTop/></div>
                <div className="bg-white rounded-[25px] shadow-main-shadow w-full"><Outlet/></div>
            </div>
        </div>
    )
}

export default LayoutMainAdmin;